import { Injectable } from '@angular/core';
import {
   ActivatedRouteSnapshot,
   CanActivate,
   CanActivateChild,
   CanLoad,
   Route,
   Router,
   RouterStateSnapshot,
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthenticationService } from '../authentication.service';
import { ROUTES } from '../enums/routes';

@Injectable({
   providedIn: 'root',
})
export class AuthGuard implements CanActivate, CanActivateChild, CanLoad {
   constructor(private authService: AuthenticationService, private router: Router) { }

   canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
      return this.checkLogin(state.url);
   }

   canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
      return this.canActivate(route, state);
   }

   canLoad(route: Route): Observable<boolean> {
      const url = route.path ? `/${route.path}` : '/';
      return this.checkLogin(url);
   }

   checkLogin(url: string): Observable<boolean> {
      if (this.authService.isAuthenticated()) {
         return of(true);
      }

      return this.authService.isAuthenticatedCookie().pipe(
         map((isAuthenticatedCookie) => {
            if (isAuthenticatedCookie) {
               return true;
            }

            // Store the attempted URL for redirecting
            // Once the user is authenticated, the app will redirect him to the redirectUrl
            this.authService.redirectUrl = url;
            // Navigate to the login page with extras
            this.router.navigate([ROUTES.LOGIN]);
            return false;
         }),
      );
   }
}
